import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Modal } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';

const DatosReserva = ({ propiedad, precios, llegada, salida, difdias, adultos, ninos, bebes, lang, ruta, config, tpvs, paypal, transferencia, stripe, paycomet, moneda, numpropiedades, websgrupo, cliente }) => {

    let { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    let resprices = [];
    let resextras = [];

    let precioBase = 0;
    let cuentaNoches = 0;
    let sumaextras = 0;

    let prepago = 0;

    let vectornumpropiedades = []

    const [mostrarTarifas, setMostrarTarifas] = useState("block");

    const [mostrarExtras, setMostrarExtras] = useState("none");

    const [mostrarDescuento, setMostrarDescuento] = useState("none");

    const [mostrarDadesClient, setMostrarDadesClient] = useState("none");

    const [mostrarInfoPago, setMostrarInfoPago] = useState("none");

    const [mostrarInfoTarjeta, setMostrarInfoTarjeta] = useState("none");

    const [mostrarPagar, setMostrarPagar] = useState("none");

    const [paso, setPaso] = useState(1);

    const toggleTarifas = (e) => {
        e.stopPropagation();
        setMostrarTarifas("block");
        setMostrarExtras("none");
        setMostrarDescuento("none");
        setMostrarDadesClient("none");
        setMostrarInfoPago("none");
        setPaso(1);
    };

    const toggleExtresTarifas = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("block");
        setMostrarDescuento("none");
        setMostrarDadesClient("none");
        setMostrarInfoPago("none");
        setPaso(2);
    };

    const toggleTarifasDescuento = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("none");
        setMostrarDescuento("block");
        setMostrarDadesClient("none");
        setMostrarInfoPago("none");
        setPaso(3);
    };

    const toggleDescuentoTarifas = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("block");
        setMostrarDescuento("none");
        setMostrarDadesClient("none");
        setMostrarInfoPago("none");
        setPaso(2);
    };

    const toggleDescuentoDadesClient = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("none");
        setMostrarDescuento("none");
        setMostrarDadesClient("block");
        setMostrarInfoPago("none");
        setPaso(4);
    };

    const toggleDadesClientDescuento = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("none");
        setMostrarDescuento("block");
        setMostrarDadesClient("none");
        setMostrarInfoPago("none");
        setPaso(3);
    };

    const toggleDadesClientInfoPago = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("none");
        setMostrarDescuento("none");
        setMostrarDadesClient("none");
        setMostrarInfoPago("block");
        setMostrarPagar("block");
        setPaso(5);
    };

    const toggleDadesInfoPagoClient = (e) => {
        e.stopPropagation();
        setMostrarTarifas("none");
        setMostrarExtras("none");
        setMostrarDescuento("none");
        setMostrarDadesClient("block");
        setMostrarInfoPago("none");
        setMostrarPagar("none");
        setPaso(4);
    };

    {/* *************** */ }

    function getArrayCookie(nombre) {
        let nombreCookie = `${nombre}=`;
        let cookiesDecodificadas = decodeURIComponent(document.cookie);
        let arrayCookies = cookiesDecodificadas.split(';');

        for (let i = 0; i < arrayCookies.length; i++) {
            let cookie = arrayCookies[i].trim();
            if (cookie.indexOf(nombreCookie) === 0) {
                try {
                    return JSON.parse(cookie.substring(nombreCookie.length, cookie.length));
                } catch (e) {
                    console.error('Error parseando cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    const cookieValue = getArrayCookie("datos");

    {/* *************** */ }

    const [idTarifaRef, setIdTarifaRef] = useState(null);
    const [priceRef, setPriceRef] = useState(null);
    const [prepagoRef, setPrepagoRef] = useState(null);
    const cantApartRef = useRef(1);
    const sumaExtrasRef = useRef(0);
    const sumaExtras2Ref = useRef(0);
    const feesRef = useRef(0);
    const pextraRef = useRef(null);
    const pextranombresRef = useRef(null);
    const preciosDiariosRef = useRef(null);

    const losextrasRef = useRef(null);

    const initialValues = cookieValue && cliente != null
        ? {
            nombre: cliente.nombre,
            apellidos: cliente.apellidos,
            email: cliente.email,
            telefono: cliente.telefono,
            documento_identidad: cliente.documento_identidad,
            ciudad: cliente.ciudad
        }
        : {
            nombre: "",
            apellidos: "",
            email: "",
            telefono: "",
            documento_identidad: "",
            ciudad: ""
        };

    const nombrecRef = useRef(initialValues.nombre);
    const apellidoscRef = useRef(initialValues.apellidos);
    const emailcRef = useRef(initialValues.email);
    const telefonocRef = useRef(initialValues.telefono);
    const documentocRef = useRef(initialValues.documento_identidad);
    const ciudadcRef = useRef(initialValues.ciudad);

    const aceptacondicionesRef = useRef(null);

    const codigodescuentoprecioRef = useRef(null);
    const codigodescuentoporcentajeRef = useRef(null);

    const formularioreservaRef = useRef(null);

    const datosreservaactualesRef = useRef(null);

    const numpropiedades0Ref = useRef(null);

    const [showHayExtraCat, setShowHayExtraCat] = useState("none");
    const pextracatRef = useRef(null);

    {/* *************** */ }
    const numtarjetaRef = useRef(null);
    const titulartarjetaRef = useRef(null);
    const fechacaducidadtarjetaRef = useRef(null);
    const cvctarjetaRef = useRef(null);

    const [cardErrors, setCardErrors] = useState({ num: null, expiry: null, cvc: null });

    const luhn = (num) => {
        const digits = num.replace(/\D/g, '');
        if (digits.length < 13 || digits.length > 19) return false;
        let sum = 0;
        let alt = false;
        for (let i = digits.length - 1; i >= 0; i--) {
            let n = parseInt(digits[i], 10);
            if (alt) { n *= 2; if (n > 9) n -= 9; }
            sum += n;
            alt = !alt;
        }
        return sum % 10 === 0;
    };

    const validateExpiry = (val) => {
        const match = val.match(/^(0[1-9]|1[0-2])\/(\d{2})$/);
        if (!match) return false;
        const now = new Date();
        const expMonth = parseInt(match[1], 10);
        const expYear = 2000 + parseInt(match[2], 10);
        return expYear > now.getFullYear() || (expYear === now.getFullYear() && expMonth >= now.getMonth() + 1);
    };

    const formatCardNumber = (e) => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 16);
        e.target.value = raw.replace(/(.{4})/g, '$1 ').trim();
        numtarjetaRef.current.dataset.raw = raw;
    };

    const handleCardBlur = (field) => {
        const errors = { ...cardErrors };
        if (field === 'num') {
            const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
            errors.num = luhn(raw) ? null : t('Número de tarjeta no válido');
        }
        if (field === 'expiry') {
            errors.expiry = validateExpiry(fechacaducidadtarjetaRef.current.value) ? null : t('Fecha caducada o formato incorrecto (MM/AA)');
        }
        if (field === 'cvc') {
            errors.cvc = /^\d{3,4}$/.test(cvctarjetaRef.current.value) ? null : t('CVV debe tener 3 o 4 dígitos');
        }
        setCardErrors(errors);
    };

    const isCardValid = () =>
        luhn((numtarjetaRef.current?.dataset.raw || numtarjetaRef.current?.value || '').replace(/\D/g, '')) &&
        validateExpiry(fechacaducidadtarjetaRef.current?.value || '') &&
        /^\d{3,4}$/.test(cvctarjetaRef.current?.value || '');

    {/* *************** */ }

    const roundN = (value, decimals) => {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }

    const handleChangeTarifa = () => {

        //console.log("Cambio tarifa");

        var numreservas = cantApartRef.current.value;

        var precioEstancia = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").value * numreservas);
        var precioExtras = (Number(sumaExtrasRef.current.value) + Number(sumaExtras2Ref.current.value)) * numreservas;
        var precioTotal = Number(precioEstancia) + Number(precioExtras);
        var prepago = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute('data-prepago'));

        var totalextratipo2 = 0;

        var nombresextras = "";
        var nombresextras2 = "";

        var extras = document.getElementsByClassName("extra");
        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            if (unextra.getAttribute('data-tipoextra') === 2) {
                var porciento = unextra.getAttribute('data-precio');
                var precioextra = (precioEstancia * porciento) / 100;
                var valorcampo = unextra.value;
                if (valorcampo === 1) {
                    totalextratipo2 += precioextra;
                }
            }
        }

        var precioextrascal = 0;

        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            var valorcampo = unextra.value;
            if (unextra.getAttribute("data-nombre") && valorcampo == 1) {
                nombresextras += (nombresextras == "" ? "" : " ") + unextra.getAttribute("data-nombre");

                var precioExtra = parseFloat(unextra.getAttribute('data-precio')) / 100;

                var tipoextra = parseInt(unextra.getAttribute('data-tipoextra'));

                var porreserva = parseInt(unextra.getAttribute('data-porreserva'));
                var porpersona = parseInt(unextra.getAttribute('data-porpersona'));
                var pordia = parseInt(unextra.getAttribute('data-pordia'));
                var pormes = parseInt(unextra.getAttribute('data-pormes'));

                var personas = parseInt(unextra.getAttribute('data-numpersonas'));
                var difdias = parseInt(unextra.getAttribute('data-numdias'));

                if (porreserva) {
                    precioExtra = precioExtra * 1;
                }
                if (porpersona) {
                    precioExtra = precioExtra * personas;
                }
                if (pordia) {
                    precioExtra = precioExtra * difdias;
                }
                if (pormes) {
                    precioExtra = precioExtra * (difdias / 30);
                }
                precioextrascal += precioExtra;

                nombresextras2 += "<div class='col-8'>" + unextra.getAttribute("data-nombre") + "</div><div class='col-4 text-end'>" + precioExtra + " " + moneda + "</div>";

            }
        }

        //pextranombresRef.current.textContent = nombresextras;

        losextrasRef.current.innerHTML = nombresextras2;

        sumaExtras2Ref.current.value = totalextratipo2;

        if (!isNaN(sumaExtrasRef.current.value)) {
            var nuevoPrecioExtras = roundN(sumaExtrasRef.current.value, 2) * numreservas;
            feesRef.current.value = nuevoPrecioExtras;
        }
        else {
            var nuevoPrecioExtras = 0;
            feesRef.current.value = 0;
        }

        if (!isNaN(sumaExtras2Ref.current.value)) {
            var nuevoPrecioExtrasTipo2 = roundN(sumaExtras2Ref.current.value, 2) * numreservas;
            var fees = roundN(feesRef.current.value, 2);

            feesRef.current.value = parseFloat(nuevoPrecioExtrasTipo2) + parseFloat(fees);
            pextraRef.current.textContent = roundN(parseFloat(fees) + parseFloat(nuevoPrecioExtrasTipo2), 2);
        }
        else {
            var nuevoPrecioExtrasTipo2 = 0;
        }

        //console.log(precioEstancia);
        //console.log(precioextrascal);

        var nuevoPrecioTotal = roundN(parseFloat(precioEstancia) + parseFloat(precioextrascal), 2);

        let incremento = 0;
        let tipoIncremento = 0;

        {/*console.log(document.querySelector("input[type='radio'][name='payments']:checked").value);*/ }
        {/*console.log(document.querySelector("input[type='radio'][name='payments']:checked").getAttribute('data-incremento'));*/ }
        {/*console.log(document.querySelector("input[type='radio'][name='payments']:checked").getAttribute("data-tipoincremento"));*/ }

        incremento = document.querySelector("input[type='radio'][name='payments']:checked").getAttribute('data-incremento');
        tipoIncremento = document.querySelector("input[type='radio'][name='payments']:checked").getAttribute("data-tipoincremento");

        let incremento2 = incremento;
        if (tipoIncremento === 1) {
            incremento2 = roundN(Number(nuevoPrecioTotal) * ((Number(incremento) / 100)), 2);
        }

        if (incremento > 0) {
            let incremento_a_mostrar = 0;
            if (tipoIncremento === 0) {
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) + Number(incremento), 2);
                incremento_a_mostrar = roundN(Number(incremento), 2);
            } else {
                incremento_a_mostrar = roundN(Number(nuevoPrecioTotal) * (Number(incremento) / 100), 2);
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) * (1 + (Number(incremento) / 100)), 2);
            }
            setShowHayExtraCat("flex");
            pextracatRef.current.textContent = incremento_a_mostrar;
        }
        else {
            setShowHayExtraCat("none");
            pextracatRef.current.textContent = 0;
        }

        var nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
        var nuevoResto = nuevoPrecioTotal - nuevoPrepago;

        var codigoDescuentoPrecio = codigodescuentoprecioRef.current.value;
        var codigoDescuentoPorcentaje = codigodescuentoporcentajeRef.current.value;

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            var precioSinDescuento = nuevoPrecioTotal;
        }
        else {
            var precioSinDescuento = 0.00;
        }
        if (codigoDescuentoPrecio > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - codigoDescuentoPrecio).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }
        if (codigoDescuentoPorcentaje > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - (precioEstancia * (codigoDescuentoPorcentaje / 100))).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }

        document.querySelectorAll(".pricebase").forEach(function (elemento) {
            elemento.textContent = roundN(Number(precioEstancia), 2) + " " + moneda;
        });

        document.querySelectorAll(".totalprice").forEach(function (elemento) {
            //console.log(nuevoPrecioTotal);
            elemento.textContent = roundN(Number(nuevoPrecioTotal), 2) + " " + moneda;
        });

        document.querySelectorAll(".prepago").forEach(function (elemento) {
            elemento.textContent = roundN(Number(nuevoPrepago), 2)
        });

        document.querySelectorAll(".feesincluded").forEach(function (elemento) {
            elemento.textContent = roundN(Number(incremento2), 2)
        });

        pextraRef.current.textContent = roundN(Number(precioExtras), 2);

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            if (codigoDescuentoPrecio > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + parseFloat(codigoDescuentoPrecio).toFixed(2);
            }
            if (codigoDescuentoPorcentaje > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + (precioEstancia * (codigoDescuentoPorcentaje / 100)).toFixed(2);
            }
        }

        setIdTarifaRef(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-tarifa"));

        //idTarifaRef.current.value = document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-tarifa");

        setPriceRef(btoa(precioEstancia));
        //priceRef.current.value = btoa(precioEstancia);
        setPrepagoRef(prepago);
        //prepagoRef.current.value = prepago;
        preciosDiariosRef.current.value = document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute('data-preciosdiarios');

        datosreservaactualesRef.current.setAttribute("data-precioestancia", (Number(precioEstancia), 2));
        datosreservaactualesRef.current.setAttribute("data-totalprice", roundN(Number(precioTotal), 2));
        datosreservaactualesRef.current.setAttribute("data-prepago", roundN(Number(nuevoPrepago), 2));

        if (prepago === 0) {
            if (document.getElementById("payments1"))
                document.getElementById("paymens1").required = false;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = false;
        }
        if (prepago > 0) {
            if (document.getElementById("payments1"))
                document.getElementById("payments1").required = true;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = true;
            if (document.getElementById("payments5"))
                document.getElementById("payments5").required = true;
            if (document.getElementById("payments6"))
                document.getElementById("payments6").required = true;
        }

        if ((((document.getElementById("elem0") && document.getElementById("elem0").checked) || (document.getElementById("payments2") && document.getElementById("payments2").checked) || (document.getElementById("payments5") && document.getElementById("payments5").checked)) && prepago < 100) ||
            (document.getElementById("payments4") && document.getElementById("payments4").checked)) {
            setMostrarInfoTarjeta("block");
            document.getElementById("numtarjeta").required = true;
            document.getElementById("titulartarjeta").required = true;
            document.getElementById("fechacaducidadtarjeta").required = true;
            document.getElementById("cvctarjeta").required = true;
        }
        else {
            setMostrarInfoTarjeta("none");
            document.getElementById("numtarjeta").required = false;
            document.getElementById("titulartarjeta").required = false;
            document.getElementById("fechacaducidadtarjeta").required = false;
            document.getElementById("cvctarjeta").required = false;

        }

    }

    const handleChangeExtra = (param) => {

        var elemento = document.querySelector("select[name='" + param + "']");

        var valor = elemento.value;
        var precioExtra = parseFloat(elemento.getAttribute('data-precio')) / 100;
        var baseExtras = parseFloat(sumaExtrasRef.current.value);
        var baseExtrasTipo2 = parseFloat(sumaExtras2Ref.current.value);

        var precioBase = datosreservaactualesRef.current.getAttribute("data-precioestancia");
        var precioExtraTarifa = datosreservaactualesRef.current.getAttribute("data-precioextratarifa");

        precioBase = precioBase - precioExtraTarifa;

        var tipoextra = parseInt(elemento.getAttribute('data-tipoextra'));

        var porreserva = parseInt(elemento.getAttribute('data-porreserva'));
        var porpersona = parseInt(elemento.getAttribute('data-porpersona'));
        var pordia = parseInt(elemento.getAttribute('data-pordia'));
        var pormes = parseInt(elemento.getAttribute('data-pormes'));

        var personas = parseInt(elemento.getAttribute('data-numpersonas'));
        var difdias = parseInt(elemento.getAttribute('data-numdias'));

        if (porreserva) {
            precioExtra = precioExtra * 1;
        }
        if (porpersona) {
            precioExtra = precioExtra * personas;
        }
        if (pordia) {
            precioExtra = precioExtra * difdias;
        }
        if (pormes) {
            precioExtra = precioExtra * (difdias / 30);
        }

        if (tipoextra === 0) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 1) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 2) {
            precioExtra = (precioBase * precioExtra) / 100;

            if (valor === "0") {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) - Number(precioExtra), 2);

            }
            else {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) + Number(precioExtra), 2);
            }
        }

        pextraRef.current.textContent = (parseFloat(sumaExtrasRef.current.value) + parseFloat(sumaExtras2Ref.current.value)) * Number(cantApartRef.current.value);

        feesRef.current.value = (parseFloat(sumaExtrasRef.current.value) + parseFloat(sumaExtras2Ref.current.value)) * Number(cantApartRef.current.value);

        handleChangeTarifa();

    }

    const handleChangeNumPropiedades = () => {
        cantApartRef.current.value = numpropiedades0Ref.current.value;
        handleChangeTarifa();
    };

    const handleChangeDiscount = () => {

        var el = document.querySelector('#nombrecodigo');

        let parameters = location.search.substring(1);
        var incrementotpv = 0;

        if (document.querySelector("input[type='radio'][name='payments1']") && document.querySelector("input[type='radio'][name='tarifa1']:checked")) {
            incrementotpv = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").attr("data-incremento"));
        }
        if (document.querySelector("#payments2") && document.querySelector("#payments2").checked) {
            incrementotpv = Number(document.querySelector("#payments2").getAttribute("data-incremento"));
        }
        if (document.querySelector("#payments5") && document.querySelector("#payments5").checked) {
            incrementotpv = Number(document.querySelector("#payments5").getAttribute("data-incremento"));
        }

        var precioEstancia = Number(document.querySelector(".tarifa1:checked").value);
        var precioExtras = Number(document.querySelector("#datosreserva").getAttribute('data-extras0'));
        var precioTotal = Number(Number(precioEstancia) + Number(precioExtras));
        var incremento = roundN((precioTotal * (incrementotpv / 100)), 2);
        var preciotpv = roundN((Number(precioTotal) + Number(incremento)), 2);
        var pagoaCuenta = roundN(preciotpv * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

        const result = axios.post('check-cliente-reserva', {
            idCodigoDescuento: el.value,
            propiedad: propiedad.id,
            entrada: llegada,
            salida: salida,
            parameters: parameters,
            dataType: 'JSON'
        })
            .then((response) => {
                const solucion = response.data;
                if (solucion.status === "success") {
                    var descuento;
                    if (solucion.tipo === 'moneda') {
                        descuento = parseFloat(solucion.descuento).toFixed(2);
                        codigodescuentoprecioRef.current.value = descuento;
                    } else {
                        descuento = (precioEstancia * (solucion.descuento / 100)).toFixed(2);
                        codigodescuentoporcentajeRef.current.value = solucion.descuento;
                    }

                    pagoaCuenta = roundN((preciotpv - descuento) * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

                    var resto = Number(preciotpv - descuento - pagoaCuenta);

                    document.querySelector('.codigo-carro').innerHTML = "<span>-" + descuento + "</span> ";
                    document.querySelector('.muestra-codigo-carro').style.display = "";
                    document.querySelector('#codigodescuento div').innerHTML = '<div className="ws-errorbox" style="display: block;" id="errorbox-1"><p className="ws-errormessage c008">Codigo de descuento valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
                else {
                    codigodescuentoprecioRef.current.value = "";
                    codigodescuentoporcentajeRef.current.value = "";
                    var resto = preciotpv - pagoaCuenta;
                    document.querySelector('.muestra-codigo-carro').style.display = "none";
                    document.querySelector('.codigo-carro').textContent = '';
                    document.querySelector('#codigodescuento div').innerHTML = '<div className="ws-errorbox" style="display: block;" id="errorbox-1"><p className="ws-errormessage">Codigo de descuento no valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
            })
    };

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(!showModal);
    }

    const handleSubmit = () => {
        //console.log("hago submit");
        if (nombrecRef.current.value && nombrecRef.current.value.replace(/\s+/g, '').length > 0 &&
            apellidoscRef.current.value && apellidoscRef.current.value.replace(/\s+/g, '').length > 0 &&
            emailcRef.current.value && emailcRef.current.value.replace(/\s+/g, '').length > 0 &&
            telefonocRef.current.value && telefonocRef.current.value.replace(/\s+/g, '').length > 0 &&
            documentocRef.current.value && documentocRef.current.value.replace(/\s+/g, '').length > 0 &&
            aceptacondicionesRef.current.checked && emailcRef.current.value.includes('@')) {
            if (prepagoRef < 100) {
                if (titulartarjetaRef.current.value.trim().length > 0 && isCardValid()) {
                    const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
                    numtarjetaRef.current.value = raw;
                    formularioreservaRef.current.submit();
                }
                else {
                    handleShowModal()
                }
            }
            else {
                formularioreservaRef.current.submit();
            }
        }
        else {
            handleShowModal()
        }
    }

    const handleBack = () => {
        window.history.back();
    }

    useEffect(() => {

        if (document.getElementById("payments2")) {
            document.getElementById("payments2").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.getElementById("payments5")) {
            document.getElementById("payments5").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.getElementById("payments3")) {
            document.getElementById("payments3").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.getElementById("payments4")) {
            document.getElementById("payments4").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.querySelector(".tpv")) {
            document.querySelector(".tpv").click(function () {
                handleChangeTarifa();
            });
        }

        if (document.querySelector(".bizum")) {
            document.querySelector(".bizum").click(function () {
                handleChangeTarifa();
            });
        }

        setTimeout(() => {
            handleChangeTarifa();
        }, 0);

    }, []);

    const [showMore, setshowMore] = useState(-1);

    let lostpvs = [];
    let losstripes = [];

    {/* *************** */ }

    let nombreobligatorios = "";
    propiedad.relacion_extras.map((unextra, index) => {
        if (unextra.obligatorio) {
            if (nombreobligatorios != "") nombreobligatorios += ", "
            nombreobligatorios += unextra.nombre
        }
    })

    {/* *************** */ }

    // 1. Primero, define el estado y la función para manejar los cambios
    const [formData, setFormData] = useState({
        firstname: initialValues.nombre,
        lastname: initialValues.apellidos,
        email: initialValues.email,
        phone: initialValues.telefono,
        documentousuario: initialValues.documento_identidad,
        ciudad: initialValues.ciudad
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // 2. Calcula si el formulario es válido
    const isFormValid = formData.firstname && formData.lastname &&
        formData.email && formData.phone &&
        formData.documentousuario;

    {/* *************** */ }


    return (
        <>
            <c-search style={{ height: "10px", display: "inline-block" }}>
            </c-search>

            <app-steps-new>
                <nav className="c-steps">
                    <ul>
                        <li>
                            <a className="btn back-steps d-block d-md-none">
                                <div className="o-icon o-icon-2">
                                    <i className="fa-solid fa-angle-left"></i>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a className={`paso1 ${paso === 1 ? 'active' : ''}`}>
                                <span className="step-n">1</span>
                                <span className="step-t">{t("Seleccionar tarifas")}</span>
                                <span className="d-block d-md-none">{t("Seleccionar tarifas")}</span>
                            </a>
                        </li>
                        <li>
                            <a className={`paso2 ${paso === 2 ? 'active' : ''}`}>
                                <span className="step-n">2</span>
                                <span className="step-t">{t("Extras")}</span>
                                <span className="d-block d-md-none">{t("Reserva. Paso 1/4")}</span>
                            </a>
                        </li>
                        <li>
                            <a className={`paso3 ${paso === 3 ? 'active' : ''}`}>
                                <span className="step-n">3</span>
                                <span className="step-t">{t("Descuento")}</span>
                                <span className="d-block d-md-none">{t("Reserva. Paso 1/4")}</span>
                            </a>
                        </li>
                        <li>
                            <a className={`paso4 ${paso === 4 ? 'active' : ''}`}>
                                <span className="step-n">4</span>
                                <span className="step-t">{t("Datos cliente")}</span>
                                <span className="d-block d-md-none">{t("Reserva. Paso 1/4")}</span>
                            </a>
                        </li>
                        <li>
                            <a className={`paso5 ${paso === 5 ? 'active' : ''}`}>
                                <span className="step-n">5</span>
                                <span className="step-t">{t("Pago")}</span>
                                <span className="d-block d-md-none">{t("Reserva. Paso 1/4")}</span>
                            </a>
                        </li>

                        <li className="d-none">
                            <a className="btn btn-close">
                                <div className="o-icon o-icon-2">
                                    <i className="fa-solid fa-xmark"></i>
                                </div>
                            </a>
                        </li>
                    </ul>
                </nav>
            </app-steps-new>

            <div className="container mt-2 mt-md-5">

                <div className="row">
                    <div className="col-md-8 desktop">

                        {/* ************** */}

                        <form method="get" action="/resumen" id="formularioreserva" ref={formularioreservaRef}>
                            <input type="hidden" name="idpropiedad" id="idPropiedad" defaultValue={propiedad.id} />
                            <input type="hidden" name="llegada" defaultValue={llegada} id="llegada" />
                            <input type="hidden" name="salida" defaultValue={salida} id="salida" />
                            <input type="hidden" name="adultos" defaultValue={adultos} />
                            <input type="hidden" name="ninos" defaultValue={ninos} />
                            <input type="hidden" name="bebes" defaultValue={bebes} />
                            <input type="hidden" name="price" id="price" defaultValue={priceRef} />
                            <input type="hidden" name="discount" id="discount" defaultValue="0" />
                            <input type="hidden" name="fees" id="fees" defaultValue={propiedad.fees / 100} ref={feesRef} />
                            <input type="hidden" name="idusuario" id="user" defaultValue={cliente != null ? cliente.id : ""} />
                            <input type="hidden" name="difdias" defaultValue={difdias} />

                            <input type="hidden" name="prepago" id="prepago" defaultValue={prepagoRef} />
                            <input type="hidden" name="solorequest" id="solorequest" defaultValue="0" />
                            <input type="hidden" name="idTarifa" id="idTarifa" defaultValue={idTarifaRef} />
                            <input type="hidden" name="cantidadAparts" id="cantidadAparts" defaultValue="1" ref={cantApartRef} />
                            <input type="hidden" name="idpolitica" id="idpolitica" defaultValue={precios[0].info_tarifa.politica_id} />

                            <input type="hidden" name="preciosDiarios" id="preciosDiarios" defaultValue="" ref={preciosDiariosRef} />

                            { /*-- ********************** TARIFES  ********************************* */}

                            <div className="metro-box-wrapper" style={{ display: mostrarTarifas }}>
                                {/* ***** */}

                                <div className="mt-4 o-heading-booking">
                                    <p className="h4">{t("Selección de Tarifas")}</p>
                                    <p className="text-sm">
                                        ({adultos} {adultos > 1 ? t("adultos") : t("adulto")}
                                        {ninos > 0
                                            ? ` ${ninos} ${ninos > 1 ? t("niños") : t("niño")}`
                                            : ""})
                                    </p>
                                </div>
                                <div className="c-item summary">
                                    <div className="c-item-gall">
                                        {
                                            propiedad.foto_principal.length != 0
                                                ?
                                                <a className="gallery-open" href={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre}>
                                                    <img src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} />
                                                </a>
                                                :
                                                <a className="gallery-open">
                                                    <img src="/images/web/bedloop-nofoto.png" alt="--" title="" className="imatge-reserva-pas2" />
                                                </a>
                                        }
                                    </div>

                                    <div className="c-item__info">
                                        <div className="c-item__header">
                                            <p className="h3 text-uppercase">{propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}</p>
                                            <div className="o-icons-bedroom">
                                                <div className="o-icons">
                                                    {Array.from({ length: propiedad.capacidad_maxima }, (_, index) => (
                                                        <i key={index} className="fa-solid fa-user usuario-icono" />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="o-list-tags">

                                        </ul>
                                        <div className="p-no text-sm-all" dangerouslySetInnerHTML={{ __html: propiedad.ladesccorta }}>
                                        </div>
                                    </div>

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>{t("Tarifa")}</th>
                                                <th>{t("Régimen")}</th>
                                                <th>{t("Ocupación")}</th>
                                                <th className="text-center">{t("Precio Noche*")}</th>
                                                <th className="text-center">{t("Precio total*")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {precios.map((unprecio, index) => {
                                                let acumulado = unprecio.suma / 100;

                                                if (index === 0) {
                                                    precioBase = acumulado.toFixed(2);
                                                }

                                                acumulado = acumulado.toFixed(2);
                                                let preciosdiarios = unprecio.calendario_sin_otas;

                                                for (let i = 0; i < preciosdiarios.length; i++) {
                                                    if (index === 0) cuentaNoches++;
                                                }

                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            {index === 0 ?
                                                                <input type="radio"
                                                                    name="tarifa1"
                                                                    className="tarifa1"
                                                                    defaultChecked
                                                                    id="tarifa"
                                                                    defaultValue={acumulado}
                                                                    data-preciosdiarios=""
                                                                    data-prepago={unprecio.info_tarifa.politica.prepago}
                                                                    data-idpolitica={unprecio.info_tarifa.politica_id}
                                                                    data-tarifa={unprecio.id}
                                                                    data-texto={unprecio.info_tarifa.politica.descripcion[lang]}
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                                :
                                                                <input type="radio"
                                                                    name="tarifa1"
                                                                    className="tarifa1"
                                                                    id="tarifa"
                                                                    defaultValue={acumulado}
                                                                    data-preciosdiarios=""
                                                                    data-prepago={unprecio.info_tarifa.politica.prepago}
                                                                    data-idpolitica={unprecio.info_tarifa.politica_id}
                                                                    data-tarifa={unprecio.id}
                                                                    data-texto={unprecio.info_tarifa.politica.descripcion[lang]}
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                            }
                                                        </td>
                                                        <td scope="row">
                                                            <strong> {unprecio.info_tarifa.nombre_web_traducido && unprecio.info_tarifa.nombre_web_traducido[lang] ? unprecio.info_tarifa.nombre_web_traducido[lang] : unprecio.info_tarifa.nombre_web}</strong>
                                                        </td>

                                                        <td>
                                                            {t("Solo Alojamiento")}
                                                        </td>
                                                        <td>
                                                            <div className="o-icons-bedroom">
                                                                <div className="o-icons">
                                                                    {Array.from({ length: propiedad.capacidad_maxima }, (_, index) => (
                                                                        <i key={index} className="fa-solid fa-user usuario-icono" />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="o-price">
                                                                <p className="price">{" " + (acumulado / cuentaNoches).toFixed(2) + " " + moneda}</p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="o-price">
                                                                <p className="price"> {" " + acumulado + " " + moneda}</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            }
                                        </tbody>
                                    </table>

                                    {
                                        propiedad.relacion_extras.length > 0 ?
                                            <div onClick={toggleExtresTarifas} className="btn btn-primary fake-disabled" style={{ marginLeft: "45%" }}>
                                                {t("Siguiente")}
                                            </div>
                                            :
                                            <div onClick={toggleTarifasDescuento} className="btn btn-primary fake-disabled" style={{ marginLeft: "45%" }}>
                                                {t("Siguiente")}
                                            </div>
                                    }


                                </div>

                                {/* ***** */}

                            </div>

                            { /*-- ********************** FINAL TARIFES  ********************************* */}

                            {/* ***************** EXTRES ***************** */}

                            <div className="metro-box-wrapper" style={{ display: mostrarExtras }}>
                                {/* ******* */}
                                <div className="o-heading-booking">
                                    <p className="h4 text-uppercase">{t("Puedes añadir los siguientes extras")}</p>
                                </div>

                                {propiedad.relacion_extras
                                    .filter(unextra => !unextra.incluido) // Solo los que no están incluidos
                                    .map((unextra, index) => {
                                        // Cálculo del precio base
                                        let baseprecio = unextra.precio;
                                        let dias_a_multiplicar = Math.min(difdias, propiedad.destino.maximo_dias);

                                        if (unextra.obligatorio) {
                                            let tipo_precio = unextra.tipo_precio;
                                            if (tipo_precio === "1") {
                                                if (unextra.por_persona === 1) {
                                                    baseprecio = baseprecio * (Number(adultos) + Number(ninos));
                                                }
                                                if (unextra.por_dia_reserva === 1) {
                                                    baseprecio = baseprecio * difdias;
                                                }
                                            } else {
                                                baseprecio = precioBase * (baseprecio / 100);
                                                if (unextra.por_persona === 1) {
                                                    baseprecio = baseprecio * (Number(adultos) + Number(ninos));
                                                }
                                                if (unextra.por_dia_reserva === 1) {
                                                    baseprecio = baseprecio * dias_a_multiplicar;
                                                }
                                            }
                                            sumaextras += (baseprecio / 100);
                                        }

                                        return (
                                            <div className="c-item selected extras"
                                                key={"e" + index}
                                                data-key={"e" + index}
                                            >
                                                <div className="c-item-gall">
                                                    {(unextra.imagen) ? (
                                                        <i className={unextra.imagen.replace("fa-lg", "") + " fa-5x"}></i>
                                                    ) : (
                                                        <i className="fa-duotone fa-check fa-5x"></i>
                                                    )}
                                                </div>

                                                <div className="c-item__info">
                                                    <div className="c-item__header">
                                                        <p className="h5 text-uppercase">{unextra.nombre}</p>
                                                    </div>
                                                    <div className="c-item__body">
                                                        <p>
                                                            <select
                                                                className="mb-0 form-select ng-pristine ng-valid ng-touched extra"
                                                                name={"extra" + unextra.servicios_extra_id}
                                                                disabled={unextra.obligatorio}
                                                                data-dialimpieza=""
                                                                data-nombre={unextra.nombre}
                                                                data-extraid={unextra.servicios_extra_id}
                                                                data-precio={baseprecio}
                                                                data-porreserva={unextra.por_reserva ? 1 : 0}
                                                                data-porpersona={unextra.por_persona ? 1 : 0}
                                                                data-pordia={unextra.por_dia_reserva ? 1 : 0}
                                                                data-pormes={unextra.por_mes_reserva ? 1 : 0}
                                                                data-numdias={difdias}
                                                                data-numpersonas={Number(adultos) + Number(ninos)}
                                                                data-tipoextra={unextra.tipo}
                                                                defaultValue={unextra.obligatorio ? 1 : 0}
                                                                onChange={() => handleChangeExtra("extra" + unextra.servicios_extra_id)}
                                                            >
                                                                <option value="0">{t("Seleccione")}</option>
                                                                <option value="1">
                                                                    {(baseprecio / 100).toFixed(2)}{' '}
                                                                    {unextra.por_reserva ? (
                                                                        moneda + " / " + t("Por reserva")
                                                                    ) : ("")}
                                                                    {unextra.por_persona ? (
                                                                        moneda + " / " + t("Por persona")
                                                                    ) : ("")}
                                                                    {unextra.por_dia_reserva ? (
                                                                        moneda + " / " + t("Por dia")
                                                                    ) : ("")}
                                                                    {unextra.por_mes_reserva ? (
                                                                        moneda + " / " + t("Por mes")
                                                                    ) : ("")}
                                                                </option>
                                                            </select>
                                                            {unextra.obligatorio ?
                                                                <input
                                                                    type="hidden"
                                                                    name={"extra" + unextra.servicios_extra_id}
                                                                    defaultValue={1}
                                                                />
                                                                :
                                                                ""
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                <input type="hidden"
                                    name="baseextras"
                                    id="baseextras"
                                    defaultValue={sumaextras}
                                    ref={sumaExtrasRef}
                                />
                                <input type="hidden"
                                    name="baseextrastipo2"
                                    id="baseextrastipo2"
                                    defaultValue="0"
                                    ref={sumaExtras2Ref}
                                />

                                <div onClick={toggleTarifas} className="btn btn-primary fake-disabled" style={{ marginLeft: "35%" }}>
                                    {t("Anterior")}
                                </div>
                                <div onClick={toggleTarifasDescuento} className="btn btn-primary fake-disabled" style={{ marginLeft: "17px" }}>
                                    {t("Siguiente")}
                                </div>
                            </div>


                            {/* ***************** FINAL EXTRES ***************** */}


                            {/* ***************** CODI DESCOMPTE ***************** */}
                            <div className="metro-box-wrapper" style={{ display: mostrarDescuento }}>
                                <div className="o-heading-booking">
                                    <p className="h4 text-uppercase">{t("Código promocional")}</p>
                                </div>
                                <fieldset className="mb-4 o_form">
                                    <div className="mb-2" id="codigodescuento">
                                        <label htmlFor="pay_name" className="form-label">{t("Código")}</label>

                                        <input type="text"
                                            className="mb-0 form-control ng-untouched ng-pristine ng-invalid" placeholder={t("Código")}
                                            name="codigodescuento"
                                            id="nombrecodigo"
                                            onKeyUp={handleChangeDiscount}
                                        />
                                        <input type="hidden"
                                            id="codigodescuentoprecio"
                                            name="codigodescuentoprecio"
                                            defaultValue=""
                                            ref={codigodescuentoprecioRef}
                                        />
                                        <input type="hidden"
                                            id="codigodescuentoporcentaje"
                                            name="codigodescuentoporcentaje"
                                            defaultValue=""
                                            ref={codigodescuentoporcentajeRef}
                                        />
                                        <input type="hidden" name="moneda2" defaultValue={moneda} />
                                        <input type="hidden" name="abreviaturamoneda2" defaultValue="EUR" />
                                        <div></div>
                                    </div>
                                </fieldset>
                                {
                                    propiedad.relacion_extras.length > 0 ?
                                        <div onClick={toggleDescuentoTarifas} className="btn btn-primary fake-disabled" style={{ marginLeft: "35%" }}>
                                            {t("Anterior")}
                                        </div>
                                        :
                                        <div onClick={toggleTarifas} className="btn btn-primary fake-disabled" style={{ marginLeft: "35%" }}>
                                            {t("Anterior")}
                                        </div>
                                }
                                <div onClick={toggleDescuentoDadesClient} className="btn btn-primary fake-disabled" style={{ marginLeft: "17px" }}>
                                    {t("Siguiente")}
                                </div>
                            </div>
                            {/* ***************** FINAL CODI DESCOMPTE ***************** */}

                            {/* ***************** DADES CLIENT ***************** */}

                            <div className="metro-box-wrapper" id="userInfo" style={{ display: mostrarDadesClient }}>
                                <div className="o-heading-booking">
                                    <p className="h4 text-uppercase">{t("Información de cobro")}</p>
                                </div>
                                <fieldset className="mb-4 o_form">
                                    <div className="row">
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="nombrec" className="form-label">{t("Nombre")} *</label>
                                            <input
                                                type="text"
                                                id="nombrec"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                ref={nombrecRef}
                                                placeholder={t("Nombre")}
                                                name="firstname"
                                                value={formData.firstname}
                                                onChange={handleInputChange}
                                                required />
                                        </div>
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="apellidosc" className="form-label">{t("Apellidos")} *</label>
                                            <input
                                                type="text"
                                                id="apellidosc"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                ref={apellidoscRef}
                                                placeholder={t("Apellidos")}
                                                name="lastname"
                                                value={formData.lastname}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="emailc" className="form-label">{t("Email")} *</label>
                                            <input
                                                type="email"
                                                id="emailc"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                ref={emailcRef}
                                                placeholder={t("Email")}
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required />
                                        </div>
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="telefonoc" className="form-label">{t("Teléfono")} *</label>
                                            <input
                                                type="text"
                                                id="telefonoc"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                ref={telefonocRef}
                                                placeholder={t("Teléfono")}
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                required />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="documentoc" className="form-label">{t("Pasaporte/ID")} *</label>
                                            <input
                                                type="text"
                                                id="documentoc"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                ref={documentocRef}
                                                placeholder={t("Pasaporte/ID")}
                                                name="documentousuario"
                                                value={formData.documentousuario}
                                                onChange={handleInputChange}
                                                required />
                                        </div>
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="ciudadc" className="form-label">{t("Ciudad")}</label>
                                            <input
                                                type="text"
                                                id="ciudadc"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                placeholder={t("Ciudad")}
                                                name="city"
                                                ref={ciudadcRef}
                                                defaultValue=""
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="comentario" className="form-label">{t("Comentario")}</label>
                                            <textarea
                                                id="comentario"
                                                className="form-control ng-untouched ng-pristine ng-invalid"
                                                rows="4"
                                                placeholder={t("Comentario")}
                                                name="comentario">
                                            </textarea>
                                        </div>
                                    </div>
                                    <div>{t("Todos los campos * son obligatorios")}</div>

                                </fieldset>

                                <div onClick={toggleDadesClientDescuento} className="btn btn-primary fake-disabled" style={{ marginLeft: "35%" }}>
                                    {t("Anterior")}
                                </div>
                                <div
                                    onClick={isFormValid ? toggleDadesClientInfoPago : undefined}
                                    className={`btn btn-primary${!isFormValid ? ' disabled' : ''}`}
                                    style={{ marginLeft: "17px" }}
                                    disabled={!isFormValid}
                                >
                                    {t("Siguiente")}
                                </div>
                            </div>

                            {/* ***************** FINAL DADES CLIENT ***************** */}

                            {/* ***************** TPV, PAYPAL, ETC ***************** */}
                            <div className="metro-box-wrapper tipopago" style={{ display: mostrarInfoPago }}>
                                <h3>{t("Información de pago")}</h3>
                                <div className="linia"></div>
                                <div className="content">
                                    <div id="paymentOption" className="payment-option-wrapper">
                                        <div className="row">
                                            {config.activa_tpv === 1 && tpvs.length > 0 ?
                                                tpvs.map((untpv, index) => {
                                                    lostpvs = lostpvs.concat(
                                                        <>
                                                            <div className="col-lg-6 col-md-12" key={"tpv" + index} data-key={"tpv" + index}>
                                                                <div className="radio-block font-icon-radio">
                                                                    <input className="payments1 radio tpv" id="elem0" name="payments" type="radio" defaultValue={"paymentsCreditCard" + untpv.id} required="" data-incremento={untpv.markup ? untpv.markup.incremento : 0} data-idtpv={untpv.id} data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0} onClick={() => handleChangeTarifa()} defaultChecked={index === 0} />
                                                                    <label htmlFor="elem0">

                                                                        {untpv.nombre_comercio} <i className="fa-brands fa-cc-visa fa-xl"></i>

                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {untpv.bizum == 1 ?
                                                                <>
                                                                    <div className='col-lg-6 col-md-12' key={"bizum" + index} data-key={"bizum" + index}>
                                                                        <div className='radio-block font-icon-radio'>
                                                                            <input className='payments1 radio tpv' id='elem2-0' name='payments' type='radio' value={"paymentsBizum" + untpv.id} required="" data-incremento={untpv.markup ? untpv.markup.incremento : 0} data-idtpv={untpv.id} data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0} onClick={() => handleChangeTarifa()} />
                                                                            <label htmlFor='elem2-0'>

                                                                                {t("Bizum")} <i className="fa-duotone fa-mobile fa-xl"></i>

                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            {untpv.google_pay == 1 ?
                                                                <>
                                                                    <div className='col-lg-6 col-md-12' key={"gp" + index}>
                                                                        <div className='radio-block font-icon-radio'>
                                                                            <input className='payments1 radio tpv' id='elem2-0' name='payments' type='radio' value={"paymentsGPay" + untpv.id} required="" data-incremento={untpv.markup ? untpv.markup.incremento : 0} data-idtpv={untpv.id} data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0} onClick={() => handleChangeTarifa()} />
                                                                            <label htmlFor='elem2-0'>

                                                                                {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            {untpv.apple_pay == 1 ?
                                                                <>
                                                                    <div className='col-lg-6 col-md-12' key={"ap" + index}>
                                                                        <div className='radio-block font-icon-radio'>
                                                                            <input className='payments1 radio tpv' id='elem2-0' name='payments' type='radio' value={"paymentsAPay" + untpv.id} required="" data-incremento={untpv.markup ? untpv.markup.incremento : 0} data-idtpv={untpv.id} data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0} onClick={() => handleChangeTarifa()} />
                                                                            <label htmlFor='elem2-0'>

                                                                                {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                        </>
                                                    )
                                                })
                                                :
                                                lostpvs = lostpvs.concat(<></>)
                                            }
                                            {lostpvs}
                                            {config.activa_paypal === 1 && paypal ?
                                                <>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="radio-block font-icon-radio">
                                                            <input id="payments2 radio" name="payments" type="radio" className="radio" value="paymentPaypal" required="" data-incremento={paypal.markup.incremento} data-tipoincremento={paypal.markup.tipo} onClick={() => handleChangeTarifa()} defaultChecked={tpvs.length === 0} />
                                                            <label htmlFor="payments2">

                                                                {t("Paypal")} <i className="fa-brands fa-paypal fa-xl"></i>

                                                            </label>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <></>
                                            }

                                            {config.activa_stripe === 1 && stripe.length > 0 ?
                                                stripe.map((unstripe, index) => {
                                                    losstripes = losstripes.concat(
                                                        <>
                                                            <div className="col-lg-6 col-md-12" key={"str" + index} data-key={"str" + index}>
                                                                <div className="radio-block font-icon-radio">
                                                                    <input className="payments5 radio" name="payments" type="radio" value={"paymentStripe" + unstripe.id} required="" data-incremento={unstripe.markup.incremento} data-tipoincremento={unstripe.markup.tipo} onClick={() => handleChangeTarifa()} defaultChecked={tpvs.length === 0 && config.activa_paypal === 0} />
                                                                    <label htmlFor="payments5">

                                                                        {unstripe.nombre_comercio && unstripe.nombre_comercio != '' ? unstripe.nombre_comercio : "Stripe"} <i className="fa-brands fa-stripe fa-xl"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                                :
                                                losstripes = losstripes.concat(<></>)
                                            }
                                            {losstripes}

                                            {config.activa_transferencia === 1 && transferencia ?
                                                <>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="radio-block font-icon-radio">
                                                            <input id="payments4 radio" name="payments" type="radio" className="radio" value="paymentTransferencia" required="" onClick={() => handleChangeTarifa()} defaultChecked={tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0} />
                                                            <label htmlFor="payments4">

                                                                {transferencia.nombre_web} <i className="fa-duotone fa-building fa-xl"></i>

                                                            </label>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <></>
                                            }
                                            {config.activa_paycomet === 1 && paycomet ?
                                                <>
                                                    {
                                                        Object.keys(paycomet.metodos_pago).map((key) => (
                                                            <div className="col-lg-6 col-md-12" key={"pc" + key} data-key={"pc" + key}>
                                                                <div className="radio-block font-icon-radio">
                                                                    <input id="payments6" name="payments" type="radio" className="radio payments6" value={"paymentPaycomet" + key} required="" onClick={() => handleChangeTarifa()} defaultChecked={tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 0 && key == 1} />
                                                                    <label htmlFor="payments6">

                                                                        {paycomet.metodos_pago[key].nombre}
                                                                        {
                                                                            paycomet.metodos_pago[key].nombre === "Tarjeta" ?
                                                                                <i className="fa-brands fa-cc-visa fa-xl ms-2"></i>
                                                                                :
                                                                                paycomet.metodos_pago[key].nombre === "PayPal" ?
                                                                                    <i className="fa-brands fa-paypal fa-xl ms-2"></i>
                                                                                    :
                                                                                    <i className="fa-duotone fa-mobile fa-xl ms-2"></i>
                                                                        }

                                                                    </label>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                    {
                                                        paycomet.apple_pay === 1 ?
                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="radio-block font-icon-radio">
                                                                    <input id="payments6" name="payments" type="radio" className="radio payments6" value="paymentPaycomet1" required="" onClick={() => handleChangeTarifa()} />
                                                                    <label htmlFor="payments6">

                                                                        {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        paycomet.google_pay === 1 ?
                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="radio-block font-icon-radio">
                                                                    <input id="payments6" name="payments" type="radio" className="radio payments6" value="paymentPaycomet1" required="" onClick={() => handleChangeTarifa()} />
                                                                    <label htmlFor="payments6">

                                                                        {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </>
                                                :
                                                <></>
                                            }

                                        </div>
                                    </div>

                                    {/* ****** */}
                                    <div className="p-4 mt-4 col-md-12 serveismotor" style={{ display: mostrarInfoTarjeta }}>
                                        <div className="gap-2 p-3 mt-2 mb-5 border border-opacity-25 d-flex align-items-start rounded-3 bg-primary bg-opacity-10 border-primary">
                                            <i className="flex-shrink-0 mt-1 fa-duotone fa-circle-info fa-lg text-primary"></i>
                                            <small className="text-secondary fw-normal lh-base">
                                                {t("No te cobraremos nada todavía. Solo necesitamos los datos de la tarjeta para garantizar tu reserva.")}
                                            </small>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label className="text-black form-label fw-bolder">{t("Titular de la tarjeta")} *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("Titular de la tarjeta")}
                                                    name="titular_tarjeta"
                                                    onChange={handleInputChange}
                                                    id="titulartarjeta"
                                                    ref={titulartarjetaRef}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="text-black form-label fw-bolder">{t("Número de tarjeta")} *</label>
                                                <input
                                                    type="text"
                                                    className={`form-control${cardErrors.num === null && numtarjetaRef.current?.value ? ' is-valid' : cardErrors.num ? ' is-invalid' : ''}`}
                                                    placeholder="0000 0000 0000 0000"
                                                    name="num_tarjeta"
                                                    id="numtarjeta"
                                                    inputMode="numeric"
                                                    maxLength="19"
                                                    ref={numtarjetaRef}
                                                    onChange={formatCardNumber}
                                                    onBlur={() => handleCardBlur('num')}
                                                />
                                                {cardErrors.num && <div className="invalid-feedback">{cardErrors.num}</div>}
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label className="text-black form-label fw-bolder">{t("Fecha caducidad")} *</label>
                                                <input
                                                    id="fechacaducidadtarjeta"
                                                    type="text"
                                                    className={`form-control${cardErrors.expiry === null && fechacaducidadtarjetaRef.current?.value ? ' is-valid' : cardErrors.expiry ? ' is-invalid' : ''}`}
                                                    placeholder="MM/AA"
                                                    name="fecha_caducidad"
                                                    maxLength="5"
                                                    inputMode="numeric"
                                                    ref={fechacaducidadtarjetaRef}
                                                    onChange={(e) => {
                                                        let v = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                        if (v.length >= 3) v = v.slice(0, 2) + '/' + v.slice(2);
                                                        e.target.value = v;
                                                    }}
                                                    onBlur={() => handleCardBlur('expiry')}
                                                />
                                                {cardErrors.expiry && <div className="invalid-feedback">{cardErrors.expiry}</div>}
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label className="text-black form-label fw-bolder">{t("CVV / CVC")} *</label>
                                                <input
                                                    type="password"
                                                    className={`form-control${cardErrors.cvc === null && cvctarjetaRef.current?.value ? ' is-valid' : cardErrors.cvc ? ' is-invalid' : ''}`}
                                                    placeholder="•••"
                                                    name="cvc_tarjeta"
                                                    maxLength="4"
                                                    inputMode="numeric"
                                                    id="cvctarjeta"
                                                    ref={cvctarjetaRef}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleCardBlur('cvc')}
                                                />
                                                {cardErrors.cvc && <div className="invalid-feedback">{cardErrors.cvc}</div>}
                                            </div>
                                            <div className="mt-4 col-12">
                                                <div className="gap-3 p-3 border border-opacity-25 d-flex align-items-center justify-content-center rounded-3 bg-success bg-opacity-10 border-success">
                                                    <i className="fa-duotone fa-shield-check fa-xl text-success"></i>
                                                    <div>
                                                        <div className="fw-semibold text-success small">{t("Pago 100% seguro")}</div>
                                                        <div className="text-muted" style={{ fontSize: "0.75rem" }}>{t("Tus datos están cifrados y protegidos con SSL")}</div>
                                                    </div>
                                                    <i className="fa-brands fa-cc-visa fa-xl text-secondary"></i>
                                                    <i className="fa-brands fa-cc-mastercard fa-xl text-secondary"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* ****** */}


                                </div>
                                <div onClick={toggleDadesInfoPagoClient} className="btn btn-primary fake-disabled" style={{ marginLeft: "45%" }}>
                                    {t("Anterior")}
                                </div>
                            </div>

                            {/* ***************** FIN TPV, PAYPAL, ETC ***************** */}
                        </form>

                        <Modal
                            show={showModal} onHide={() => setShowModal(false)}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>{t("Error")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="clearfix mb-20 ml-20 row">
                                    {t("Asegúrate de completar los campos marcados con *")}
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* ****** */}

                    </div >
                    <div className="col-md-4">
                        <app-side-bottom-bar-new>

                            <div className="c-cart-mob">
                                <div className="c-cart-mob__left">
                                    <p className="text-xs">{t("TOTAL RESERVA")}</p>
                                    <p className="text-lg nowrap">
                                        <strong className="pricebase">{precioBase + " " + moneda}</strong>
                                    </p>
                                    <button type="button" className="text-xs btn btn-link">(moneda del hotel)</button>
                                </div>
                                <div className="c-cart-mob__right">
                                    <button type="button"
                                        className="btn btn-primary w-100 fake-disabled"
                                        disabled={!isFormValid}
                                    >
                                        {prepagoRef > 0 ?
                                            <>
                                                <span id="titulopagarmobile">{t("Pagar") + " " + t("Ahora")}</span>
                                            </>
                                            :
                                            <span id="titulopagarmobile">t("Confirmar")</span>
                                        }
                                    </button>
                                </div>

                                <button type="button" className="btn c-cart-mob__btn-collap">
                                    <span className="visually-hidden">{t("Ver detalles")}</span>
                                    <div className="icon">
                                        <i className="fa-solid fa-angle-up>"></i>
                                    </div>
                                </button>
                            </div>
                            <div className="c-cart">
                                <div className="c-cart__head">
                                    <p>{t("Detalles reserva")}</p>
                                    <div className="btns">
                                        <phone-list-dropdown>
                                            <div ngbdropdown="" autoclose="outside" className="header__csupp o-dropdown btn-group o-separador dropdown">
                                                <button data-tag-id="hdr_con_lk_open" type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-basic btn-mov" aria-expanded="false">
                                                    <div className="header__mobile-icon d-md-none">
                                                        <i className="fa-solid fa-phone"></i>
                                                    </div>
                                                    <span className="d-none d-md-block">{config.telefono_fiscal}</span>
                                                </button>
                                                <div ngbdropdownmenu="" aria-labelledby="hdr_con_lk_open" className="dropdown-menu o-dropdown__menu o-dropdown-bg-white">
                                                    <div className="o-dropdown-content">
                                                        <div className="o-dropdown-header">
                                                            <p className="o-dropdown-header-title"> {t("CONTÁCTANOS")} </p>
                                                            <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-icon btn-close" aria-expanded="false">
                                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                                                <div className="o-dropdown-header-icon">
                                                                    <i className="fa-solid fa-xmark"></i>

                                                                </div>
                                                            </button>
                                                        </div>
                                                        <div className="o-dropdown-body">
                                                            <ul className="p-0 m-0 o-dropdown__links">
                                                                <li className="flex-row gap-1 mb-4 align-items-center">
                                                                    <div className="o-icon">
                                                                        <i className="fa-solid fa-phone"></i>

                                                                    </div>
                                                                    <span>{t("Atención al Cliente")}</span>
                                                                </li>
                                                                <li className="mb-3">
                                                                    <button type="button" data-tag-id="hdr_con_bt_rcall" className="btn btn-primary"> {t("Te llamamos gratis")} </button>
                                                                </li>

                                                                <li>
                                                                    <a href={`tel:${config.telefono_fiscal}`} data-tag-id="hdr_con_ph_0">
                                                                        <span className="text-uppercase">España</span>
                                                                        <strong>{config.telefono_fiscal}</strong>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </phone-list-dropdown>
                                        <button type="button" className="btn btn-close">
                                            <span className="visually-hidden">shared.close</span>
                                        </button>
                                    </div>
                                    <button type="button" className="btn c-cart-mob__btn-collap">
                                        <span className="visually-hidden">{t("Ocultar detalles")}</span>
                                        <div className="icon">
                                            <i className="fa-solid fa-angle-down"></i>
                                        </div>
                                    </button>
                                </div>
                                <div className="c-cart__content">

                                    <div className="o-card c-cart-book">
                                        <p className="c-cart-book_title">
                                            <strong>{t("MI RESERVA")}</strong>
                                        </p>
                                        <p className="text-xs text-center text-gray">
                                            {t("Del")} {llegada.split("-")[2] + "-" + llegada.split("-")[1] + "-" + llegada.split("-")[0]} {t("al")} {salida.split("-")[2] + "-" + salida.split("-")[1] + "-" + salida.split("-")[0]} <br />{cuentaNoches + " " + t("Noches")}  - {(Number(adultos) + Number(ninos))} {t("personas")} </p>

                                        <div className="collapse">

                                        </div>
                                        <ul className="c-cart-book__pretotal">
                                            <li>
                                                <span>{t("IMPORTE")}</span>
                                                <span className="pricebase">{precioBase + " " + moneda}</span>
                                            </li>
                                            <li>
                                                <span>{t("Cargos y tasas de servicio")}</span>
                                            </li>
                                            <li id="hayextracat" style={{ display: showHayExtraCat }}>
                                                <span>{t("Tasas")}</span>
                                                <span id="extracat" ref={pextracatRef}></span> {moneda}
                                            </li>
                                            <li>
                                                {/* <span id="nombresextras" ref={pextranombresRef}>{t(nombreobligatorios)}</span> */}
                                                <span id="nombresextras" className="row" style={{ width: "100%" }} ref={losextrasRef}>{t(nombreobligatorios)}</span>
                                                <span style={{ display: "none" }}>
                                                    <span id="pextra" ref={pextraRef}>{(propiedad.fees / 100).toFixed(2)}</span> {moneda}
                                                </span>
                                            </li>

                                            <div className="muestra-codigo-carro" style={{ display: "none" }}>
                                                <span>{t("Código")}</span>
                                                <span>
                                                    <span className="codigo-carro"></span> {moneda}
                                                </span>
                                            </div>
                                        </ul>

                                        <div className="c-cart-book__total row">
                                            <div className="col-auto">
                                                <p>
                                                    <span className="text-uppercase">{t("TOTAL RESERVA")}</span>
                                                </p>
                                            </div>
                                            <div className="col-auto">
                                                <p className="text-lg nowrap totalprice">{(parseFloat(precioBase) + parseFloat(propiedad.fees / 100)).toFixed(2)} {moneda}</p>
                                            </div>
                                        </div>
                                        <button type="button" className="text-xs btn btn-link">{t("Impuestos incluidos excepto Imp. Pernoctación")}</button>


                                        <button type="button"
                                            className="mb-1 btn btn-primary w-100 d-none d-md-block fake-disabled" onClick={() => handleSubmit()}
                                            disabled={!isFormValid}
                                        >
                                            {prepagoRef > 0 ?
                                                <>
                                                    <i className="fa-duotone fa-credit-card"></i> <span id="titulopagar">{t("Pagar") + " " + t("Ahora")}</span> <span className="prepago">
                                                        {
                                                            tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 1 && transferencia ?
                                                                0
                                                                :
                                                                ((parseFloat(precioBase) + parseFloat(propiedad.fees / 100)) * parseFloat(precios[0].info_tarifa.politica.prepago / 100)).toFixed(2)
                                                        }
                                                    </span> <span id="pagarmoneda">{moneda}</span>
                                                </>
                                                :
                                                <>
                                                    <span id="titulopagar">{t("Confirmar")}</span> <span className="prepago"></span> <span id="pagarmoneda"></span>
                                                </>
                                            }
                                        </button>

                                        <p className="mt-4 mb-0 nolineheight">
                                            <input type="checkbox" name="aceptacondiciones" required defaultChecked id="aceptacondiciones" ref={aceptacondicionesRef} />
                                            <span className="small ms-2 text-start">
                                                {t("Al reservar, acepta los")}<a href={"/" + preidioma + t("terminos")} target="_blank">  {t("términos y condiciones")}</a>, {t("así como la")} <a href={"/" + preidioma + t("politica-de-cancelacion")} target="_blank">{t("política de cancelación")}</a>. *
                                            </span>
                                        </p>
                                        <p className="mt-4 mb-0 nolineheight">
                                            <input type="checkbox" name="aceptacondiciones2" id="aceptacondiciones2" />
                                            <span className="small ms-2 text-start">
                                                {t("Acepto recibir información comercial, incluso por medios electrónicos")}.
                                            </span>
                                        </p>
                                    </div>
                                    <div className="o-card c-cart-help">
                                        <p className="text-lg">
                                            <strong>{t("¿NECESITAS AYUDA?")}</strong>
                                        </p>
                                        <button type="button" className="btn btn-primary"> {t("Te llamamos gratis")}</button>


                                        <a href={`mailto:${config.email_fiscal}`}>{config.email_fiscal}</a>
                                        <a href={`tel:${config.telefono_fiscal}`}>{config.telefono_fiscal}</a>

                                    </div>
                                </div>
                            </div>

                        </app-side-bottom-bar-new>

                    </div>

                    {/*-- *************** DATOS RESERVA ****************** */}

                    <span id="datosreserva" data-precioestancia0={precioBase} data-totalprice0={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-prepago0={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-resto0="0.00" data-extras0={propiedad.fees} data-tpcprepago="100" data-fees0="0" data-precioextratarifa="0"></span>
                    <span id="datosreservaactuales" ref={datosreservaactualesRef} data-precioestancia={precioBase} data-totalprice={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-prepago={parseFloat(precioBase) + parseFloat(propiedad.fees / 100)} data-resto="0.00" data-extras={propiedad.fees} data-tpcprepago="100" data-fees="0" data-precioextratarifa="0"></span>

                    {/*-- ************************************************ */}
                </div >
            </div >

        </>
    );
}

export default DatosReserva;
